export default function getCookieName({ name, env }) {
  return `${env}_${name}`;
}
